module.exports = __webpack_public_path__ + "img/arrow.7824d7e6.svg";